/* KULTA instant-nav prefetch — additive, safe, no visual change.
   Prefetches internal page HTML on hover / pointer-down / touch so moving between
   pages (product -> collection -> product) feels instant. instant.page-style. */
(function () {
  'use strict';

  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return; // respect data-saver / slow links

  var link = document.createElement('link');
  var supportsPrefetch = !!(link.relList && link.relList.supports && link.relList.supports('prefetch'));
  if (!supportsPrefetch) return;

  var done = Object.create(null);
  var timer = null;

  function eligible(a) {
    if (!a || !a.href || !a.origin) return false;
    if (a.origin !== location.origin) return false;                         // same-origin only
    if (a.pathname === location.pathname && a.search === location.search) return false;
    if (done[a.href]) return false;
    if (a.hasAttribute('download')) return false;
    if (a.target && a.target !== '_self') return false;
    var p = a.pathname || '';
    if (/^\/(cart|checkout|account|apps|services)(\/|$)/.test(p)) return false;
    if (/\.(jpg|jpeg|png|gif|webp|svg|pdf|zip|json|js|css)$/i.test(p)) return false;
    if (a.search && /[?&](add|atc|quantity)=/i.test(a.search)) return false;  // skip add-to-cart links
    return true;
  }

  function prefetch(href) {
    if (done[href]) return;
    done[href] = true;
    var l = document.createElement('link');
    l.rel = 'prefetch';
    l.href = href;
    l.as = 'document';
    document.head.appendChild(l);
  }

  function clear() { if (timer) { clearTimeout(timer); timer = null; } }

  document.addEventListener('mouseover', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (!eligible(a)) return;
    clear();
    timer = setTimeout(function () { prefetch(a.href); }, 65);          // small delay: ignore fast fly-overs
    a.addEventListener('mouseout', clear, { once: true });
  }, { capture: true, passive: true });

  function eager(e) {
    if (e.type === 'mousedown' && (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return; // primary-click intent only
    var a = e.target && e.target.closest ? e.target.closest('a') : null;
    if (eligible(a)) prefetch(a.href);                                   // commit on intent (mousedown/touch)
  }
  document.addEventListener('mousedown', eager, { capture: true, passive: true });
  document.addEventListener('touchstart', eager, { capture: true, passive: true });
})();
